export enum TransferTestIds {
  ACCORDION = 'transfer_accordion',
  SUBMIT = 'transfer_submit',
}
